// extracted by mini-css-extract-plugin
export const background = "CloudHero-module--background--1a9g_";